import React, { memo, useMemo, type CSSProperties, type ElementType } from 'react';
import { motion } from 'motion/react';

export type ShimmerProps = {
  children: string;
  as?: ElementType;
  className?: string;
  duration?: number;
  spread?: number;
};

const ShimmerComponent = ({
  children,
  as: Component = 'span',
  className = '',
  duration = 2,
  spread = 2,
}: ShimmerProps) => {
  const MotionComponent = motion.create(Component as any);

  const dynamicSpread = useMemo(
    () => (children?.length ?? 0) * spread,
    [children, spread]
  );

  return (
    <MotionComponent
      animate={{ backgroundPosition: '0% center' }}
      className={`core-shimmer ${className}`.trim()}
      initial={{ backgroundPosition: '100% center' }}
      style={
        {
          '--shimmer-spread': `${dynamicSpread}px`,
        } as CSSProperties
      }
      transition={{
        repeat: Number.POSITIVE_INFINITY,
        duration,
        ease: 'linear',
      }}
    >
      {children}
    </MotionComponent>
  );
};

export const Shimmer = memo(ShimmerComponent);

Shimmer.displayName = 'Shimmer';

